import { z } from 'zod'
import { AreaCodeSchema, ZoneIdSchema, ZoneStateValueSchema } from '../enums.js'

export const ZoneStateSchema = z.object({
  zone: ZoneIdSchema,
  state: ZoneStateValueSchema,
  contract_ids: z.array(z.string().min(1)),
  gaps: z.array(AreaCodeSchema),
})
export type ZoneState = z.infer<typeof ZoneStateSchema>
